import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined';
import { Box, Stack, Typography } from '@mui/material';

export function SubgridEmptyState({ message }: { message: string }) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={1}
      sx={{ gridColumn: '1 / -1', minHeight: 156, borderBottom: '1px solid #edebe9', py: 2 }}
    >
      <Box
        sx={{
          width: 82,
          height: 82,
          borderRadius: '50%',
          display: 'grid',
          placeItems: 'center',
          bgcolor: '#b3b3b3',
          color: 'common.white',
        }}
      >
        <GridOnOutlinedIcon sx={{ fontSize: 50 }} />
      </Box>
      <Typography>{message}</Typography>
    </Stack>
  );
}
